const LAWYER = 'lawyer';
const COMPANY = 'company';

enum ProfileProductId {
  'lawyer' = 1,
  'company',
}

export { LAWYER, COMPANY, ProfileProductId };
